module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Muttenz-73919677933e2d5cdecf752a35578765.png";